// @flow
import React from 'react'

import Score from '../Score'

import classes from './styles'

const isItNewQuestion = (nextProps, props) => (Boolean(nextProps.question) && props.question.id !== nextProps.question.id)

function decodeHtml(html) {
  const txt = document.createElement("textarea")
  txt.innerHTML = html
  return txt.value
}

const leftKeyCode = 37
const rightKeyCode = 39

let appearAnimation = null
let tickInterval = null

class Question extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      opacity: 0,
      correctPictureIndex: this._getRandomIndex(props.question.pictures),
    }
    this._showImages()
  }

  componentWillReceiveProps = (nextProps) =>  {
    if (!isItNewQuestion(nextProps, this.props)) return

    this.setState({
      opacity: 0,
      correctPictureIndex: this._getRandomIndex(nextProps.question.pictures)
    })

    this._showImages()
  }

  shouldComponentUpdate =(nextProps, nextState) => isItNewQuestion(nextProps, this.props) || nextState.opacity !== this.state.opacity

  componentWillMount = () => {
    document.addEventListener("keydown", this.handleKeys, false)

    tickInterval = setInterval(() => {
      this.props.tick()
    }, 1000)
  }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.handleKeys, false);
    clearInterval(appearAnimation)
    clearInterval(tickInterval)
  }

  _showImages = (animationTime = 900) => {
    const animationStep = 10
    const opacityStep = animationStep / animationTime

    appearAnimation = setInterval(() => {
      if (this.state.opacity < 1)  {
        this.setState({
          opacity: this.state.opacity + opacityStep
        })
      } else {
        clearInterval(appearAnimation)
      }
    }, animationStep)
  }

  handleKeys = (e) => {
    if (e.keyCode === leftKeyCode) this.handleAnswer(0)
    if (e.keyCode === rightKeyCode) this.handleAnswer(1)
  }

  _getRandomIndex = (pictures: Array<Picture>): number => Math.floor(Math.random() * pictures.length)

  handleAnswer = (pictureIndex) => {
    clearInterval(appearAnimation)

    const questionId = this.props.question.id
    const isAnswerCorrect = pictureIndex === this.state.correctPictureIndex
    const scoreModificator = isAnswerCorrect ? 1 : 0

    if (! this.state.isHide) {
      this.props.answer({ questionId, isAnswerCorrect })
      this.props.modifyScore(scoreModificator)
    }
  }

  render() {
    const { question } = this.props
    const { correctPictureIndex, opacity } = this.state

    const title: string = question.pictures[correctPictureIndex].title

    return (
      <div>
        <Score />

        <div style={{ opacity }}>
          <div className={classes.titleWrapper}>
            <h2 className={classes.title}>
              {decodeHtml(title)}
            </h2>
          </div>

          <div className={classes.images}>
            {question.pictures.map((picture, i) => (
              <div
                key={`picture-${i}`}
                className={classes.imagesAndArrow}
              >
                <div
                  className={classes.imageWrapper}
                >
                  <img
                    onClick={this.handleAnswer.bind(this, i)}
                    className={classes.image}
                    src={picture.src}
                    alt="alt"
                  />
                </div>

              </div>
            ))}
          </div>

          <div className={classes.help}>
            Для выбора обложки используйте стрелки на клавиатуре или кликайте мышкой.
          </div>

        </div>
      </div>
    )
  }
}
/*
<div className={getArrowsClasses(i)}>
  {i === 0 ?
    <img className={getArrowClasses(i)} src={`${process.env.PUBLIC_URL}/left_arrow.svg`} alt=""/>
    :
    <img className={getArrowClasses(i)} src={`${process.env.PUBLIC_URL}/left_arrow.svg`} alt=""/>
  }
</div>

function getArrowsClasses(i) {
  if (i === 0) return classes.arrows
  return [classes.arrows, classes.arrowsRight].join(' ')
}

function getArrowClasses(i) {
  if (i === 0) return classes.arrow
  return [classes.arrow, classes.arrowRight].join(' ')
}
*/

Question.propTypes = {
  question: React.PropTypes.object,
  answer: React.PropTypes.func.isRequired,
  modifyScore: React.PropTypes.func.isRequired,
}

export default Question


// WEBPACK FOOTER //
// ./src/components/Question/Question.jsx